"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DumbappApprovalParameters = require("./DumbappApprovalParameters");
Object.keys(_DumbappApprovalParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappApprovalParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappApprovalParameters[key];
    }
  });
});
var _DumbappApprovalRequest = require("./DumbappApprovalRequest");
Object.keys(_DumbappApprovalRequest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappApprovalRequest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappApprovalRequest[key];
    }
  });
});
var _DumbappArgumentType = require("./DumbappArgumentType");
Object.keys(_DumbappArgumentType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappArgumentType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappArgumentType[key];
    }
  });
});
var _DumbappArgument = require("./DumbappArgument");
Object.keys(_DumbappArgument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappArgument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappArgument[key];
    }
  });
});
var _DumbappConfig = require("./DumbappConfig");
Object.keys(_DumbappConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappConfig[key];
    }
  });
});
var _DumbappContractStep = require("./DumbappContractStep");
Object.keys(_DumbappContractStep).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappContractStep[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappContractStep[key];
    }
  });
});
var _DumbappData = require("./DumbappData");
Object.keys(_DumbappData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappData[key];
    }
  });
});
var _DumbappDynamic = require("./DumbappDynamic");
Object.keys(_DumbappDynamic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappDynamic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappDynamic[key];
    }
  });
});
var _Erc20ApprovalParameters = require("./Erc20ApprovalParameters");
Object.keys(_Erc20ApprovalParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Erc20ApprovalParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Erc20ApprovalParameters[key];
    }
  });
});
var _Erc721AllApprovalParameters = require("./Erc721AllApprovalParameters");
Object.keys(_Erc721AllApprovalParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Erc721AllApprovalParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Erc721AllApprovalParameters[key];
    }
  });
});
var _Erc721ApprovalParameters = require("./Erc721ApprovalParameters");
Object.keys(_Erc721ApprovalParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Erc721ApprovalParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Erc721ApprovalParameters[key];
    }
  });
});
var _DumbappEtherStep = require("./DumbappEtherStep");
Object.keys(_DumbappEtherStep).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappEtherStep[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappEtherStep[key];
    }
  });
});
var _DumbappRequiresApproval = require("./DumbappRequiresApproval");
Object.keys(_DumbappRequiresApproval).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappRequiresApproval[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappRequiresApproval[key];
    }
  });
});
var _DumbappRequiresAsset = require("./DumbappRequiresAsset");
Object.keys(_DumbappRequiresAsset).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappRequiresAsset[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappRequiresAsset[key];
    }
  });
});
var _DumbappStepArguments = require("./DumbappStepArguments");
Object.keys(_DumbappStepArguments).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappStepArguments[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappStepArguments[key];
    }
  });
});
var _DumbappStepBase = require("./DumbappStepBase");
Object.keys(_DumbappStepBase).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappStepBase[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappStepBase[key];
    }
  });
});
var _DumbappStep = require("./DumbappStep");
Object.keys(_DumbappStep).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappStep[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappStep[key];
    }
  });
});
var _DumbappUndeterminedApproval = require("./DumbappUndeterminedApproval");
Object.keys(_DumbappUndeterminedApproval).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappUndeterminedApproval[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappUndeterminedApproval[key];
    }
  });
});
var _DumbappValue = require("./DumbappValue");
Object.keys(_DumbappValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappValue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappValue[key];
    }
  });
});
var _DumbappWalletStrategy = require("./DumbappWalletStrategy");
Object.keys(_DumbappWalletStrategy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappWalletStrategy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappWalletStrategy[key];
    }
  });
});
var _ApprovalExtra = require("./ApprovalExtra");
Object.keys(_ApprovalExtra).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ApprovalExtra[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ApprovalExtra[key];
    }
  });
});
var _DeployedExtra = require("./DeployedExtra");
Object.keys(_DeployedExtra).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeployedExtra[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DeployedExtra[key];
    }
  });
});
var _DumbappExtras = require("./DumbappExtras");
Object.keys(_DumbappExtras).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappExtras[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappExtras[key];
    }
  });
});
var _LottoExtra = require("./LottoExtra");
Object.keys(_LottoExtra).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LottoExtra[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LottoExtra[key];
    }
  });
});
var _TokenData = require("./TokenData");
Object.keys(_TokenData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TokenData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TokenData[key];
    }
  });
});
var _TransferExtraBase = require("./TransferExtraBase");
Object.keys(_TransferExtraBase).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TransferExtraBase[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TransferExtraBase[key];
    }
  });
});
var _TransferExtraErc = require("./TransferExtraErc20");
Object.keys(_TransferExtraErc).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TransferExtraErc[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TransferExtraErc[key];
    }
  });
});
var _TransferExtraErc2 = require("./TransferExtraErc721");
Object.keys(_TransferExtraErc2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TransferExtraErc2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TransferExtraErc2[key];
    }
  });
});
var _UniswapExtra = require("./UniswapExtra");
Object.keys(_UniswapExtra).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UniswapExtra[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UniswapExtra[key];
    }
  });
});
var _DumbappCallSourceParameters = require("./DumbappCallSourceParameters");
Object.keys(_DumbappCallSourceParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappCallSourceParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappCallSourceParameters[key];
    }
  });
});
var _DumbappDynamicSourceParameters = require("./DumbappDynamicSourceParameters");
Object.keys(_DumbappDynamicSourceParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappDynamicSourceParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappDynamicSourceParameters[key];
    }
  });
});
var _DumbappFeeSourceParameters = require("./DumbappFeeSourceParameters");
Object.keys(_DumbappFeeSourceParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappFeeSourceParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappFeeSourceParameters[key];
    }
  });
});
var _DumbappJsonSourceParameters = require("./DumbappJsonSourceParameters");
Object.keys(_DumbappJsonSourceParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappJsonSourceParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappJsonSourceParameters[key];
    }
  });
});
var _DumbappLiteralSourceParameters = require("./DumbappLiteralSourceParameters");
Object.keys(_DumbappLiteralSourceParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappLiteralSourceParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappLiteralSourceParameters[key];
    }
  });
});
var _DumbappOtherSourceParameters = require("./DumbappOtherSourceParameters");
Object.keys(_DumbappOtherSourceParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappOtherSourceParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappOtherSourceParameters[key];
    }
  });
});
var _DumbappSource = require("./DumbappSource");
Object.keys(_DumbappSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappSource[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappSource[key];
    }
  });
});
var _DumbappStepsSourceParameters = require("./DumbappStepsSourceParameters");
Object.keys(_DumbappStepsSourceParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappStepsSourceParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappStepsSourceParameters[key];
    }
  });
});
var _DumbappUniswapSourceParameters = require("./DumbappUniswapSourceParameters");
Object.keys(_DumbappUniswapSourceParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappUniswapSourceParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappUniswapSourceParameters[key];
    }
  });
});
var _DumbappSubmissionDataValues = require("./DumbappSubmissionDataValues");
Object.keys(_DumbappSubmissionDataValues).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappSubmissionDataValues[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappSubmissionDataValues[key];
    }
  });
});
var _DumbappFormInput = require("./DumbappFormInput");
Object.keys(_DumbappFormInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappFormInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappFormInput[key];
    }
  });
});
var _DumbappFormValues = require("./DumbappFormValues");
Object.keys(_DumbappFormValues).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappFormValues[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappFormValues[key];
    }
  });
});
var _DumbappInputValues = require("./DumbappInputValues");
Object.keys(_DumbappInputValues).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappInputValues[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappInputValues[key];
    }
  });
});
var _DumbappQueryValues = require("./DumbappQueryValues");
Object.keys(_DumbappQueryValues).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappQueryValues[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappQueryValues[key];
    }
  });
});
var _DumbappSubmissionStepData = require("./DumbappSubmissionStepData");
Object.keys(_DumbappSubmissionStepData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappSubmissionStepData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappSubmissionStepData[key];
    }
  });
});
var _DumbappSubmissionStepError = require("./DumbappSubmissionStepError");
Object.keys(_DumbappSubmissionStepError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappSubmissionStepError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappSubmissionStepError[key];
    }
  });
});
var _DumbappSubmissionStepNotice = require("./DumbappSubmissionStepNotice");
Object.keys(_DumbappSubmissionStepNotice).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappSubmissionStepNotice[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappSubmissionStepNotice[key];
    }
  });
});
var _DumbappValues = require("./DumbappValues");
Object.keys(_DumbappValues).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DumbappValues[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappValues[key];
    }
  });
});
var _VarsVariableDumbapp = require("./VarsVariableDumbapp");
Object.keys(_VarsVariableDumbapp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VarsVariableDumbapp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsVariableDumbapp[key];
    }
  });
});
//# sourceMappingURL=index.js.map